{
  "link": {
    "invalidTitle": "Lien expiré ou invalide",
    "invalidMessage": "Utilisez le lien reçu par email ou demandez un nouveau lien à l’expéditeur."
  },
  "login": {
    "title": "Connectez-vous",
    "email": "Email",
    "emailPlaceholder": "Ex : contact{'@'}boomerang.com",
    "password": "Mot de passe",
    "passwordPlaceholder": "Saisir votre mot de passe",
    "submit": "Me connecter",
    "twoFactorTitle": "Vérification 2FA",
    "twoFactorCode": "Code de vérification reçu par email",
    "verifyTwoFactor": "Vérifier le code",
    "resendTwoFactorCode": "Renvoyer le code",
    "twoFactorSent": "Un code de vérification vous a été envoyé par email",
    "selectCollaborator": "Sélectionnez un collaborateur",
    "submitCollaborator": "S’identifier",
    "forgotPasswordText": "Mot de passe oublié ?",
    "forgotPasswordButton": "Réinitialiser",
    "success": "Connexion réussie",
    "noCollaborator": "Aucun collaborateur n'est disponible pour ce compte"
  },
  "forgotPassword": {
    "title": "Mot de passe oublié",
    "email": "Email",
    "emailPlaceholder": "Ex : contact{'@'}boomerang.com",
    "submit": "Envoyer",
    "success": "Un email de réinitialisation vous a été envoyé"
  },
  "resetPassword": {
    "title": "Réinitialisez votre mot de passe",
    "password": "Mot de passe",
    "confirmPassword": "Confirmation du mot de passe",
    "passwordPlaceholder": "Saisir votre mot de passe",
    "confirmPasswordPlaceholder": "Confirmer votre mot de passe",
    "submit": "Modifier",
    "success": "Mot de passe modifié avec succès"
  },
  "confirmation": {
    "title": "Renseignez votre mot de passe",
    "password": "Nouveau mot de passe",
    "confirmPassword": "Confirmez votre mot de passe",
    "passwordPlaceholder": "Saisir votre mot de passe",
    "confirmPasswordPlaceholder": "Confirmer votre mot de passe",
    "submit": "Modifier",
    "success": "Mot de passe créé avec succès"
  }
}
